import { Button } from "@anu-its/ts-react-components";
import {
  MagnifyingGlass,
  Xmark,
} from "@anu-its/ts-react-components/icons/simple";
import { useEffect, useState } from "react";
import { FilterItem } from "./interface";

const CourseSearch = ({ updateFilter, value, setErrorMessage }: FilterItem) => {
  const [courseInput, setCourseInput] = useState(value || "");

  useEffect(() => {
    if (setErrorMessage) setErrorMessage("");
  }, [courseInput, setErrorMessage]);

  const submitCourseSearch = () => {
    const courseQuery = courseInput.trim();
    if (courseQuery.length > 2) {
      updateFilter({ courseQuery: courseQuery }, true);
    } else {
      if (setErrorMessage) setErrorMessage("Please enter 3 characters or more");
    }
  };

  const handleCourseInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.trim() === "") {
      setCourseInput("");
      updateFilter({ courseQuery: "" }, true);
    } else {
      setCourseInput(e.target.value);
    }
  };

  useEffect(() => {
    setCourseInput(value || "");
  }, [value]);

  return (
    <div className="flex grow gap-3">
      <div className="relative pl-6 pr-2 w-64 flex grow items-center border border-black dark:border-white bg-white dark:bg-gray-800 rounded-md">
        <label htmlFor="course-search" className="sr-only">
          Search For Course
        </label>
        <span className="absolute left-2">
          <MagnifyingGlass />
        </span>
        <input
          id="course-search"
          type="text"
          value={courseInput}
          onChange={(e) => handleCourseInputChange(e)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              submitCourseSearch();
            }
          }}
          placeholder="Search Course Code or Name e.g. ASTR1001, Astrophysics ...."
          className="pl-8 pr-8 w-full outline-none border-none !bg-white text-black placeholder-uni-gray"
        />

        {courseInput && (
          <button
            onClick={() => {
              setCourseInput("");
              updateFilter({ courseQuery: "" }, true);
            }}
            className="ml-2 px-2 hover:text-black border-none hover:border-[1px]"
          >
            <Xmark size="sm" />
          </button>
        )}
      </div>

      <Button onClick={submitCourseSearch} variant="secondary" size="small">
        Search Courses
      </Button>
    </div>
  );
};

export default CourseSearch;
